import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/PayPlatform/';

const state = {};

const mutations = {};

const actions = {

  UnifiedOrder({commit}, view) {
    return request.PromiseCall(basePath, 'UnifiedOrder', view);
  },


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/PayPlatform/index.js